import { useMemo } from "react";
import { pickEmptyDetailPrompt } from "../data/emptyStates";

export default function ConversationDetailEmpty() {
  const prompt = useMemo(() => pickEmptyDetailPrompt(), []);

  return (
    <div
      className="flex min-h-0 flex-1 flex-col items-center justify-center overflow-hidden px-6"
      role="status"
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <p
          aria-hidden
          className="text-[40px] font-semibold leading-none text-default-500"
        >
          {prompt.emoji}
        </p>
        <p className="max-w-[22em] text-pretty text-base leading-6 text-default-400">
          {prompt.text}
        </p>
      </div>
    </div>
  );
}
